import Experience from './core/Experience.js';

window.addEventListener('DOMContentLoaded', () => {
  const canvas = document.querySelector('canvas.webgl');
  const experience = new Experience(canvas);

  // 1. Hide Loading Screen
  const loadingScreen = document.getElementById('loading-screen');
  setTimeout(() => {
    if (loadingScreen) {
      loadingScreen.classList.add('hidden');
    }
  }, 350);

  // 2. Character Switcher
  const btnChar0 = document.getElementById('btn-char-0');
  const btnChar1 = document.getElementById('btn-char-1');
  const btnChar2 = document.getElementById('btn-char-2');

  function updateActiveButton(activeIndex) {
    if (btnChar0) btnChar0.classList.toggle('active', activeIndex === 0);
    if (btnChar1) btnChar1.classList.toggle('active', activeIndex === 1);
    if (btnChar2) btnChar2.classList.toggle('active', activeIndex === 2);
  }

  if (btnChar0) {
    btnChar0.addEventListener('click', () => {
      if (experience.world && experience.world.character) {
        experience.world.character.switchCharacter(0);
        updateActiveButton(0);
      }
    });
  }

  if (btnChar1) {
    btnChar1.addEventListener('click', () => {
      if (experience.world && experience.world.character) {
        experience.world.character.switchCharacter(1);
        updateActiveButton(1);
      }
    });
  }

  if (btnChar2) {
    btnChar2.addEventListener('click', () => {
      if (experience.world && experience.world.character) {
        experience.world.character.switchCharacter(2);
        updateActiveButton(2);
      }
    });
  }

  // 3. Theme Toggle (Vercel Black vs Pastel Light)
  const btnTheme = document.getElementById('btn-theme');
  const themeIcon = document.getElementById('theme-icon');
  const themeLabel = document.getElementById('theme-label');

  if (btnTheme) {
    btnTheme.addEventListener('click', () => {
      const isDark = experience.toggleTheme();
      themeIcon.textContent = isDark ? '☀️' : '🌙';
      themeLabel.textContent = isDark ? 'Modo Claro' : 'Modo Oscuro';
    });
  }

  // 4. Spin / Jump Button Trigger
  const btnSpin = document.getElementById('btn-spin');
  if (btnSpin) {
    btnSpin.addEventListener('click', () => {
      if (experience.world && experience.world.character) {
        experience.world.character.triggerReaction();
      }
    });
  }

  // 5. Update cursor coordinates on HUD
  const statCoords = document.getElementById('stat-coords');
  if (statCoords) {
    experience.time.on('tick', () => {
      if (experience.mouse) {
        const x = experience.mouse.target.x.toFixed(2);
        const y = experience.mouse.target.y.toFixed(2);
        statCoords.textContent = `X: ${x} | Y: ${y}`;
      }
    });
  }
});
